const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        navbarTitle: 'Patient*innen-Portal Stadtspital Zürich',
        welcomeText:
            'Mit dem Patient*innen-Portal vom Stadtspital Zürich behalten Sie stets den Überblick über Ihre Spitaltermine und haben jederzeit Zugriff auf alle wichtigen Informationen rund um Ihre Gesundheit.',
    },
    __RELATIVE_SOURCE_FILE__
);
